import { getApiUrl } from "../utils/get-api-url";
import { init } from "../units/launch-darkly";
import { LD_USER_DEFAULT_CONTEXT } from "../constants";

declare let CONFIG: any;

export const requestResetPassword = async (username: string) => {
  const flags = await init({
    key: CONFIG.envConfig.launchDarklyID,
    context: LD_USER_DEFAULT_CONTEXT
  });
  const hasUserServices = flags["user-services"] === true;

  let apiUrl, fullUrl, fetchBody;
  if (hasUserServices) {
    apiUrl = getApiUrl("userservices");
    fullUrl = `${apiUrl}/requestReset`;
    fetchBody = { username, client: "agentportal" };
  } else {
    const path = window.location.pathname;
    const callbackPath = `${window.location.origin}${path.substring(
      0,
      path.lastIndexOf("/")
    )}`;
    fetchBody = {
      "reset-callback": `${callbackPath}/resetpassword.html?reset-token={{token}}`
    };
    apiUrl = getApiUrl("agencywolf");
    fullUrl = `${apiUrl}/users/${username}/password`;
  }

  const response = await fetch(fullUrl, {
    method: "POST",
    body: JSON.stringify(fetchBody),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  });

  const { statusText, ok, status } = response;

  if (!ok || status !== 202) Promise.reject(statusText);

  return Promise.resolve();
};
